import React from 'react';
import Popup from '@components/Popup';
import styles from './index.module.css';
import blackUserWelcomePopupTitle from '@assets/Participation/black_user_welcome.png';

const BlackUserWelcomePopup = ({ isVisible, onPositiveClicked }) => {
  return (
    <Popup
      visible={isVisible}
      TitleComponent={
        <div className={styles.blackUserWelcomeTitleContainer}>
          <img
            src={blackUserWelcomePopupTitle}
            className={styles.blackUserWelcomePopupImg}
            alt=""
          />
          <div className={styles.blackUserWelcomeTitleText}>
            ブラックプランへようこそ
          </div>
        </div>
      }
      messages={[
        'ブラック審査に合格した上位3%の女性とマッチングされます。',
        'ぜひ、特別なデートをお楽しみください。'
      ]}
      messageClassName={styles.messageClassName}
      positiveButtonTitle={'閉じる'}
      positiveButtonClassName={styles.positiveButtonClassName}
      onPositiveClicked={onPositiveClicked}
      disableClose
      bodyStyle="blackUserWelcomePopupBody"
    />
  );
};

export default BlackUserWelcomePopup;
